import namespace from './namespace';

export default {
    [namespace.mutations.SET_MAPPINGS_VALUES] (state, responseData) {
        if (responseData.mappings !== undefined) {
            state[namespace.state.MAPPINGS] = responseData.mappings;
        }
        if (responseData.available !== undefined) {
            state[namespace.state.AVAILABLE_VALUES] = responseData.available;
        }
    },
    [namespace.mutations.SET_JIRA_VALUES] (state, responseData) {
        const tfsValues = Object.fromEntries(
            Object.entries(state[namespace.state.AVAILABLE_VALUES])
                  .filter(([key, value]) => value.visible && value.kind === namespace.kinds.TFS)
        );
        const jiraValues = responseData;
        state[namespace.state.AVAILABLE_VALUES] = Object.assign(tfsValues, jiraValues.available);
    },
    [namespace.mutations.SHOW_LOADER] (state, loaderVisible) {
        state[namespace.state.LOADER_VISIBLE] = loaderVisible;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/mappings/mutations.js